import { useFormik } from "formik";
import { adminCreatePatrolLocation } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";

const AddModalActivityLocation = ({ show, onCloseClick, getData }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      category: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required(
        "Nama lokasi aktivitas pekerjaan harus diisi!"
      ),
      category: Yup.array().min(1, "Kategori karyawan harus diisi!"),
    }),
    onSubmit: (values) => {
      const formattedValues = {
        name: values.name,
        category: values.category.map((cat: any) => cat.value),
      };

      adminCreatePatrolLocation(formattedValues)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Lokasi Aktivitas Pekerjaan <b>{response?.name}</b> berhasil
              ditambahkan!
            </div>
          );
          validation.resetForm();
        })
        .catch(() => {});
    },
  });

  const comboCategory = [
    { value: "EMPLOYEE", label: "EMPLOYEE" },
    { value: "SECURITY", label: "SECURITY" },
    { value: "CLEANING_SERVICE", label: "CLEANING SERVICE" },
    { value: "OFFICE_BOY", label: "OFFICE BOY" },
    { value: "DRIVER", label: "DRIVER" },
    { value: "GARDENER", label: "GARDENER" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Tambah Lokasi Aktivitas Pekerjaan
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Nama Lokasi Aktivitas Pekerjaan
            </Label>
            <Input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Nama Lokasi Aktivitas Pekerjaan"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.errors.name && validation.touched.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-3">
            <Label htmlFor="categoty" className="form-label">
              Kategori Karyawan
            </Label>
            <Select
              value={validation.values.category || []}
              onChange={(e: any) => {
                validation.setFieldValue("category", e);
              }}
              options={comboCategory}
              closeMenuOnSelect={false}
              isMulti
              className={`basic-multi-select ${
                validation.errors.category && validation.touched.category
                  ? "is-invalid"
                  : ""
              }`}
              classNamePrefix="select"
              placeholder="Pilih Kategori Karyawan"
            />
            {validation.errors.category && validation.touched.category ? (
              <div className="invalid-feedback d-block">
                {validation.errors.category}
              </div>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Tambah
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

AddModalActivityLocation.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
};

export default AddModalActivityLocation;
